import { render } from "./KSPagination.vue?vue&type=template&id=452fbbe8"
import script from "./KSPagination.vue?vue&type=script&lang=js"
export * from "./KSPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__